export { generateClient } from './API.mjs';
export { CONNECTION_STATE_CHANGE, ConnectionState, GraphQLAuthError, events } from '@aws-amplify/api-graphql';
export { del, get, head, isCancelError, patch, post, put } from '@aws-amplify/api-rest';
export { ApiError } from '@aws-amplify/core/internals/utils';
//# sourceMappingURL=index.mjs.map
